import branch from "branch-sdk";

import { logAnalyticsEvent } from "utility/FirebaseAnalytics";
import { logError } from "utility/Function";

import constant from "../Constant";

const logUTMParams = (data) => {
  const eventName = "campaign_details";
  const eventParams = {
    source: data["utm_source"] || data["~channel"],
    medium: data["utm_medium"] || data["~feature"],
    campaign: data["utm_campaign"] || data["~campaign"],
    term: data["utm_term"],
    content: data["utm_content"],
  };

  if (
    eventParams.source !== undefined &&
    eventParams.medium !== undefined &&
    eventParams.campaign !== undefined
  ) {
    logAnalyticsEvent(eventName, eventParams);
  }
};

export function initBranch() {
  branch.init(constant.BRANCH_KEY, (err, data) => {
    console.debug("Branch initialized", err, data);

    if (data) {
      logUTMParams(data.data_parsed);
    }

    if (err) {
      logError("Error initializing branch", err, data);
    }
  });
}

export function setBranchUserId(userId) {
  if (userId === null || userId === undefined) {
    return;
  }

  branch.init(constant.BRANCH_KEY);
  branch.setIdentity(userId, (err, data) => {
    console.debug("Branch user id set", err, data);
    if (err) {
      logError("Error setting branch user id", err, data);
    }
  });
}

export function logOutBranchUser() {
  branch.init(constant.BRANCH_KEY);
  branch.logout((err, data) => {
    console.debug("Branch user logged out", err, data);
    if (err) {
      logError("Error logging out branch user", err, data);
    }
  });
}
